import DateFnsUtils from "@date-io/date-fns";
import { IconButton, Tooltip } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import AssessmentIcon from "@material-ui/icons/Assessment";
import PublishIcon from "@material-ui/icons/Publish";
import CachedIcon from "@material-ui/icons/Cached";
import ChatIcon from "@material-ui/icons/Chat";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import "date-fns";
import MaterialTable, { MTableToolbar } from "material-table";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  addOtcManualProductAction,
  addOtcProductAction,
  addPhysicalInventoryAction,
  addRxProductAction,
} from "../../../../../store/inventory/actions";
import { getSuppliers } from "../../../Ancillary/SupplierManagement/helper/supplierManagementHelper";
import { getSessionData } from "../../../base/helper/baseHelper";
import Base from "../../../base/views/base";
import ConfirmationDialog from "../../../base/views/ConfirmationDialog";
import Popup from "../../../base/views/Popup";
import SelectableSearch from "../../../base/views/SelectableSearch";
import LandingPageFooter from "../../../LandingPage/views/LandingPageFooter";
import AddManualOtcProductForm from "../../PhysicalInventory/views/AddManualOtcProductForm";
import AddOtcProductForm from "../../PhysicalInventory/views/AddOtcProductForm";
import AddRxProductForm from "../../PhysicalInventory/views/AddRxProductForm";
import GoodReceivablePhysicalInventoryForm from "../../PhysicalInventory/views/GoodReceivablePhysicalInventoryForm";
import {
  CalculateUpcFromBarcode,
  DeleteCaptureGoods,
  DeleteInventoryStage,
  GetCommentsStageInventory,
  GetCaptureGoods,
  GetUpcDetailsFromBarcode,
  ScanCaptureGoods,
  SubmitCaptureGoods,
  UpdateStageInventory,
  UpdateCommentsStageInventory,
} from "../helper/CaptureReceivedGoodsHelper";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CommentPopup from "../../../base/views/CommentPopup";
// import TablePagination from "@material-ui/core/TablePagination";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      maxBodyHeight: "100%",
    },
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: "5px",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(8px)",
  },
  switch: {
    marginLeft: "2rem",
    width: "80%",
  },
}));

function CaptureReceivedGoods(props) {
  const classes = useStyles();
  const store = JSON.parse(getSessionData({ key: "store" }));
  // eslint-disable-next-line
  const [userId, setUserId] = useState(getSessionData({ key: "userId" }));
  // eslint-disable-next-line
  const [storeId, setStoreId] = useState(store.storeid);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [totalQtyCount, setTotalQtyCount] = useState(0);
  const [supplierData, setSupplierData] = useState({ load: false, values: [] });
  const [openDialog, setOpenDialog] = useState(false);
  const [openOTCManualDialog, setOpenOTCManualDialog] = useState(false);
  const [openRxDialog, setOpenRxDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [openOTCPopup, setOpenOTCPopup] = useState(false);
  const [openRxPopup, setOpenRxPopup] = useState(false);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [recordForEditForOTC, setRecordForEditForOTC] = useState(null);
  const [recordForEditForRx, setRecordForEditForRx] = useState(null);
  const [recordForEditForManualOTC, setRecordForEditForManualOTC] = useState(
    null
  );
  const [gridData, setGridData] = useState([]);
  const [deleteCaptureGoodsObj, setDeleteCaptureGoodsObj] = useState([]);
  const [moduleAccess, setModuleAccess] = useState({});
  const [opentoteDialog, setOpentoteDialog] = useState(false);
  const [opensupplierDialog, setOpensupplierDialog] = useState(false);
  const [openReceivedGoodsDialog, setOpenReceivedGoodsDialog] = useState(false);
  const [previousTote, setPreviousTote] = useState("");
  const [previousSupplierId, setPreviousSupplierId] = useState(0);
  const [previousBarCode, setPreviousBarCode] = useState("");
  const [openDoubleConfirmDialog, setOpenDoubleConfirmDialog] = useState(false);
  const [openCommentPopup, setOpenCommentPopup] = useState(false);
  const [
    confirmDeleteMultipleDialog,
    setConfirmDeleteMultipleDialog,
  ] = useState(false);
  const [ndc, setNdc] = useState("");
  const [comment, setComment] = useState("");
  const [initialLoaded, setInitialLoaded] = useState(false);

  // const [pageNumber, setPageNumber] = useState(1);
  // const [pageSize, setPageSize] = useState(10);
  const history = useHistory();

  const handleChecked = (e) => {
    if (e.target.value === "OTC") {
      setOpenOTCManualDialog(true);
    } else if (e.target.value === "RX") {
      setOpenOTCManualDialog(false);
    }
  };

  useEffect(() => {
    if (openOTCManualDialog) {
      onOTCManualOkButtonClick();
    } else {
      onOTCManualCancelButtonClick();
    }

    // eslint-disable-next-line
  }, [openOTCManualDialog]);

  const currentDate =
    selectedDate.getFullYear() +
    "/" +
    (selectedDate.getMonth() + 1) +
    "/" +
    selectedDate.getDate();
  const [captureGoods, setCaptureGoods] = useState({
    user_id: userId,
    store_id: storeId,
    tote_number: "",
    supplier: "",
    barcode: "",
    load_date: currentDate,
    selectedSupplier: { id: 0, optionname: "" },
  });
  const {
    captureGoodsResponse,
    addPhysicalInventory,
    addOtcProduct,
    addRxProduct,
    addOtcManualProduct,
  } = props;

  useEffect(() => {
    const userModules = JSON.parse(getSessionData({ key: "userModules" }));
    const inventoryModule = userModules.find(
      (module) => module.modulename === "Inventory Management"
    );
    setModuleAccess(inventoryModule);
    getCaptureGoods();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (captureGoodsResponse != null && initialLoaded) {
      // Quick fix - initialLoaded
      // Problem - After scanning from Physical Inventory, if we navigate here (GR), it shows the Physical Inventory items
      // Looks like it uses the same redux for GR and PI
      // Solution - This prevents UI from showing the PI data until the actual GR data is loaded,
      // after which the redux gets updated on next scan
      setGridData(captureGoodsResponse);

      setCaptureGoods({
        ...captureGoods,
        barcode: "",
      });
      calculateTotalQty(captureGoodsResponse, true);
    }
    // eslint-disable-next-line
  }, [captureGoodsResponse]);

  const getCaptureGoods = () => {
    if (userId !== "" && storeId !== "") {
      GetCaptureGoods(userId, storeId)
        .then((response) => {
          setInitialLoaded(true);
          if (response && response.length > 0) {
            calculateTotalQty(response, true);
            setGridData(response);
            setCaptureGoods({
              ...captureGoods,
              selectedSupplier: {
                id: response[0].supplierid,
                optionname: response[0].supplier,
              },
              supplier: response[0].supplier,
            });
            setOpenReceivedGoodsDialog(true);
          }
        })
        .catch((err) => {});
    }
  };

  const formatDate = (date) => {
    return (
      date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate()
    );
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setCaptureGoods({
      ...captureGoods,
      load_date: formatDate(date),
    });
  };

  const updateBarCodeField = (e) => {
    setCaptureGoods({
      ...captureGoods,
      barcode: e.target.value,
    });
  };

  const updateField = (e) => {
    setCaptureGoods({
      ...captureGoods,
      [e.target.name]: e.target.value,
    });
  };

  const handleCommentSubmit = () => {
    var data = {
      user_id: userId,
      store_id: storeId,
      ndc: ndc,
      comment: comment,
    };
    UpdateCommentsStageInventory(data)
      .then((response) => {
        setComment("");
        setOpenCommentPopup(false);
        setNdc("");
      })
      .catch((err) => {});
  };

  const getComments = (event, rowData) => {
    setNdc(rowData.ndc);
    GetCommentsStageInventory({
      user_id: userId,
      store_id: storeId,
      ndc: rowData.ndc,
    }).then((response) => {
      if (response && response.length > 0) {
        setComment(response[0].message);
      }
      setOpenCommentPopup(true);
    });
  };

  const toteonBlur = (e) => {
    if (previousTote && e.target.value && e.target.value !== previousTote) {
      setOpentoteDialog(true);
    }
  };
  const SupplieronBlur = (e) => {
    if (
      previousSupplierId &&
      captureGoods.selectedSupplier &&
      captureGoods.selectedSupplier.id &&
      captureGoods.selectedSupplier.id !== previousSupplierId
    ) {
      setOpensupplierDialog(true);
    }
  };

  const Scan = (e) => {
    if (e.target.id === "barcode" && (e.type === "click" || e.which === 13)) {
      ScanCaptureGoods(captureGoods)
        .then((response) => {
          if (response && response.length > 0) {
            setPreviousTote(captureGoods.tote_number);
            setPreviousSupplierId(captureGoods.selectedSupplier.id);
            calculateTotalQty(response, true);
            setGridData(response);
            setCaptureGoods({
              ...captureGoods,
              barcode: "",
            });
          } else {
            if (response.error[0].message === "Invaid UPC Number") {
              setOpenDialog(true);
            } else if (response.error[0].message === "OTC Product") {
              onOTCOkButtonClick();
              setPreviousBarCode("");
            } else if (response.error[0].message === "Rx OTC Product") {
              setOpenRxDialog(true);
              setPreviousBarCode("");
            } else {
              setCaptureGoods({
                ...captureGoods,
                barcode: "",
              });
            }
          }
        })
        .catch((err) => {});
    }
  };

  const onsupplierOkButtonClick = () => {
    UpdateStageInventory(captureGoods)
      .then((response) => {
        if (response && response.length > 0) {
          calculateTotalQty(response, true);
          setGridData(response);
          setOpensupplierDialog(false);
        }
      })
      .catch((err) => {});
  };

  const ontoteOkButtonClick = () => {
    UpdateStageInventory(captureGoods)
      .then((response) => {
        if (response && response.length > 0) {
          calculateTotalQty(response, true);
          setGridData(response);
          setOpentoteDialog(false);
        }
      })
      .catch((err) => {});
  };

  const onReceivedGoodsOkButtonClick = () => {
    setOpenReceivedGoodsDialog(false);
    setOpenDoubleConfirmDialog(false);
    var data = {
      user_id: userId,
      store_id: storeId,
    };
    DeleteInventoryStage(data)
      .then((response) => {
        setGridData([]);
        setCaptureGoods({
          ...captureGoods,
          supplier: "",
          selectedSupplier: { id: 0, optionname: "" },
          barcode: "",
        });
        setTotalQtyCount(0);
      })
      .catch((err) => {});
  };
  const onReceivedGoodsCancelClick = () => {
    setOpenReceivedGoodsDialog(false);
    setOpenDoubleConfirmDialog(false);
    if (gridData && gridData.length > 0) {
      const getLastYear = parseInt(
        gridData[gridData.length - 1].loaddate.split("-")[0]
      );
      const getLastMonth = parseInt(
        gridData[gridData.length - 1].loaddate.split("-")[1]
      );
      const getLastDate = parseInt(
        gridData[gridData.length - 1].loaddate.split("-")[2]
      );
      setSelectedDate(new Date(getLastYear, getLastMonth - 1, getLastDate));
      setCaptureGoods({
        ...captureGoods,
        tote_number: gridData[gridData.length - 1].toteno,
      });
    }
  };

  const calculateTotalQty = (response, add) => {
    if (response && response.length > 0) {
      var sum = 0;
      for (var item in response) {
        if (add) {
          sum += parseInt(response[item].quantity_by_ndc);
        } else {
          sum -= parseInt(response[item].quantity_by_ndc) * -1;
        }
        setTotalQtyCount(sum);
      }
    } else {
      setTotalQtyCount(0);
    }
  };

  const deleteCaptureGoods = (e, rowData) => {
    e.preventDefault();
    setOpenDeleteDialog(true);
    setDeleteCaptureGoodsObj({
      user_id: userId,
      store_id: storeId,
      ndc: rowData.ndc,
      lot: rowData.lot,
      quantity: rowData.quantity_by_ndc,
    });
  };

  const Submit = (e) => {
    e.preventDefault();
    if (gridData && gridData.length > 0) {
      const currentTote = captureGoods.tote_number;
      const currentSupplier = captureGoods.selectedSupplier.optionname;
      SubmitCaptureGoods(captureGoods)
        .then((response) => {
          setCaptureGoods({
            ...captureGoods,
            user_id: userId,
            store_id: storeId,
            tote_number: "",
            supplier: "",
            barcode: "",
            load_date: formatDate(selectedDate),
            selectedSupplier: { id: 0, optionname: "" },
          });
          if (response && response.length > 0) {
            setGridData(
              gridData.filter(
                (item) =>
                  item.toteno !== currentTote ||
                  item.supplier !== currentSupplier
              )
            );
            setPreviousTote("");
            setPreviousSupplierId(0);
          }
        })
        .catch((err) => {});
    }
  };

  const loadingSupplier = () => {
    setSupplierData({ ...supplierData, load: true });
    getSuppliers(storeId)
      .then((response) => {
        let dropdownData = [];
        if (response.data.length)
          dropdownData = response.data.map((obj) => ({
            id: obj.supplier_id,
            optionname: obj.name,
          }));
        setSupplierData({ load: false, values: dropdownData });
      })
      .catch((err) => {});
  };

  const handleSupplierChange = (event, value) => {
    if (value && value.id) {
      setCaptureGoods({
        ...captureGoods,
        selectedSupplier: { id: value.id, optionname: value.optionname },
        supplier: value.optionname,
      });
    } else {
      setCaptureGoods({
        ...captureGoods,
        selectedSupplier: {},
        supplier: "",
      });
    }
  };

  const onOkButtonClick = () => {
    CalculateUpcFromBarcode(captureGoods.barcode).then((response) => {
      setOpenDialog(false);
      setPreviousBarCode("");
      setRecordForEdit({
        barcode: captureGoods.barcode,
        name: "",
        strength: "",
        dosageform: "",
        packsize: "",
        ndc: "",
        upc: response,
      });
      setOpenPopup(true);
      setCaptureGoods({
        ...captureGoods,
        barcode: "",
      });
    });
  };

  const onOTCOkButtonClick = () => {
    var data = {
      user_id: userId,
      store_id: storeId,
      barcode: captureGoods.barcode,
    };

    GetUpcDetailsFromBarcode(data).then((upcDetailResponse) => {
      if (upcDetailResponse !== undefined) {
        setOpenOTCManualDialog(false);
        setRecordForEditForOTC({
          description: upcDetailResponse.description,
          ndc: upcDetailResponse.ndc,
          packsize: upcDetailResponse.packsize,
          upc: upcDetailResponse.upc,
          serialno: "",
          expirydate: null,
          lot: "",
          qty: "1",
        });
        setOpenOTCPopup(true);
        setCaptureGoods({
          ...captureGoods,
          barcode: "",
        });
        setPreviousBarCode("");
      } else {
        setOpenOTCPopup(false);
        setOpenOTCManualDialog(true);
        setOpenPopup(true);
        setPreviousBarCode(captureGoods.barcode);
      }
    });
  };

  const onRxOkButtonClick = () => {
    var data = {
      user_id: userId,
      store_id: storeId,
      barcode: captureGoods.barcode,
    };
    GetUpcDetailsFromBarcode(data).then((upcDetailResponse) => {
      if (upcDetailResponse !== undefined) {
        setOpenRxDialog(false);
        setRecordForEditForRx({
          description: upcDetailResponse.description,
          ndc: upcDetailResponse.ndc,
          packsize: upcDetailResponse.packsize,
          upc: upcDetailResponse.upc,
          serialno: "",
          expirydate: null,
          lot: "",
          qty: "1",
        });
        setOpenRxPopup(true);
      } else {
        setOpenRxDialog(false);
        setOpenRxPopup(false);
      }
      setCaptureGoods({
        ...captureGoods,
        barcode: "",
      });
    });
  };

  const onOTCManualOkButtonClick = () => {
    setRecordForEditForManualOTC({
      upc: captureGoods.barcode === "" ? previousBarCode : captureGoods.barcode,
      ndc: "",
      strength: "",
      description: "",
      packsize: "",
      manufacturename: "",
      nonreturnable: "",
      formula: "",
      dcqty: "",
    });
  };

  const onOTCManualCancelButtonClick = () => {
    setRecordForEdit({
      barcode:
        captureGoods.barcode === "" ? previousBarCode : captureGoods.barcode,
      name: "",
      strength: "",
      dosageform: "",
      packsize: "",
      ndc: "",
      upc: captureGoods.barcode === "" ? previousBarCode : captureGoods.barcode,
    });
  };

  const onDeleteOkClick = (confirmDeleteMultiple = false) => {
    setOpenDeleteDialog(false);
    if (!deleteCaptureGoodsObj) return;
    const hasMultiple = deleteCaptureGoodsObj.quantity > 1;

    if (hasMultiple && confirmDeleteMultiple !== true) {
      setConfirmDeleteMultipleDialog(true);
      return;
    }
    DeleteCaptureGoods(deleteCaptureGoodsObj)
      .then((response) => {
        setGridData(response);
        setDeleteCaptureGoodsObj({});
        setConfirmDeleteMultipleDialog(false);
        calculateTotalQty(response, false);
      })
      .catch((err) => {});
  };

  const addOrEdit = (resetForm) => {
    resetForm();
    setRecordForEdit(null);
    setOpenPopup(false);
  };

  const addOrEditForOTC = (resetForm) => {
    resetForm();
    setRecordForEditForOTC(null);
    setOpenOTCPopup(false);
  };

  const addOrEditForRx = (resetForm) => {
    resetForm();
    setRecordForEditForRx(null);
    setOpenRxPopup(false);
  };

  const addOrEditForManualOTC = (resetForm) => {
    resetForm();
    setRecordForEditForManualOTC(null);
    setOpenPopup(false);
  };

  const enableDoubleConfirm = () => {
    setOpenDoubleConfirmDialog(true);
  };

  const confirmDeleteMultipleClick = () => {
    onDeleteOkClick(true);
  };

  return (
    <div style={{ display: "flex" }}>
      <Base showBaseMenu={true} title="Goods Receivables">
        <CssBaseline />
        <Grid container spacing={3} style={{ marginTop: "1.5%" }}>
          <Grid item xs={12} sm={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid style={{ justifyContent: "space-between" }}>
                <KeyboardDatePicker
                  margin="normal"
                  id="date-picker-dialog"
                  label="Invoice Date"
                  format="MM/dd/yyyy"
                  autoOk={true}
                  okLabel={""}
                  cancelLabel={""}
                  value={selectedDate}
                  onChange={handleDateChange}
                  className={classes.submit}
                  fullWidth
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid container direction="row" item xs={12} sm={3}>
            <Grid item xs={10}>
              <div style={{ paddingTop: 25, justifyContent: "space-between" }}>
                <SelectableSearch
                  required
                  value={captureGoods.selectedSupplier}
                  data={supplierData}
                  name="supplier"
                  label="Supplier"
                  id="supplier"
                  autoFocus={true}
                  loading={loadingSupplier}
                  onChangeEvent={handleSupplierChange}
                  variantType="standard"
                  onBlur={SupplieronBlur}
                ></SelectableSearch>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div
                style={{
                  paddingTop: 50,
                  marginLeft: 15,
                  justifyContent: "space-between",
                }}
              >
                <Tooltip tabIndex="-1" title="Add Supplier">
                  <IconButton
                    aria-label="add"
                    size="small"
                    onClick={() =>
                      history.push("/ancillary/supplierManagement")
                    }
                    color="primary"
                    style={{ color: "rgb(22, 177, 255)" }}
                    {...{
                      disabled:
                        moduleAccess.createaccess === "Y" ? false : true,
                    }}
                  >
                    <AddCircleOutlineIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              value={captureGoods.tote_number}
              autoComplete="toteNumber"
              name="tote_number"
              variant="standard"
              required
              fullWidth
              id="toteNumber"
              label="Enter your TOTE number"
              className={classes.submit}
              onChange={updateField}
              onBlur={toteonBlur}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <div tabIndex="-1" onKeyDown={Scan}>
              <TextField
                value={captureGoods.barcode}
                autoComplete="barcode"
                name="barcode"
                variant="standard"
                required
                fullWidth
                id="barcode"
                label="Scan your barcode"
                autoFocus
                {...{
                  disabled: moduleAccess.createaccess === "Y" ? false : true,
                }}
                className={classes.submit}
                onChange={updateBarCodeField}
              />
            </div>
          </Grid>
        </Grid>
        <div className={classes.root}>
          <MaterialTable
            title={"Received Goods - Total Qty: " + totalQtyCount}
            columns={[
              {
                title: "Tote#",
                field: "toteno",
                cellStyle: {
                  paddingLeft: 50,
                  width: "6%",
                },
                headerStyle: {
                  paddingLeft: 50,
                },
              },
              {
                title: "Supplier",
                field: "supplier",
                cellStyle: {
                  width: "5%",
                },
              },
              {
                title: "Description",
                field: "description",
                cellStyle: {
                  width: "40%",
                },
              },
              {
                title: "NDC/UPC",
                field: "ndc",
                cellStyle: {
                  paddingLeft: 50,
                  width: "15%",
                },
                headerStyle: {
                  paddingLeft: 50,
                },
              },
              {
                title: "NDC Qty",
                field: "quantity_by_ndc",
                cellStyle: {
                  width: "10%",
                },
              },
              {
                title: "Lot#",
                field: "lot",
                cellStyle: {
                  width: "12%",
                },
              },
              {
                title: "Expiry Date",
                field: "expirationdate",
                cellStyle: {
                  width: "12%",
                },
              },
            ]}
            data={gridData}
            components={{
              Toolbar: (props) => (
                <Box display="flex">
                  <Box flexGrow={1}>
                    <MTableToolbar {...props} />
                  </Box>
                  <Box paddingBottom={1.5} paddingTop={2}>
                    <Button
                      onClick={(e) => {
                        Submit(e);
                      }}
                      fullWidth={true}
                      color="primary"
                      variant="contained"
                      style={{ backgroundColor: "rgb(22, 177, 255)" }}
                      size="medium"
                      {...{
                        disabled:
                          moduleAccess.createaccess === "Y" ? false : true,
                      }}
                    >
                      Submit to Inventory
                    </Button>
                  </Box>
                  <Tooltip title="Create New Session">
                    <IconButton
                      color="primary"
                      size="medium"
                      style={{ color: "rgb(22, 177, 255)" }}
                      onClick={() => {
                        setOpenReceivedGoodsDialog(true);
                      }}
                    >
                      <CachedIcon fontSize="inherit" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Upload EDI">
                    <IconButton
                      color="primary"
                      size="medium"
                      style={{ color: "rgb(22, 177, 255)" }}
                      onClick={() => history.push("/uploads")}
                    >
                      <PublishIcon fontSize="inherit" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Generate Report">
                    <IconButton
                      color="secondary"
                      size="medium"
                      style={{ color: "rgb(22, 177, 255)" }}
                      onClick={() =>
                        history.push("/reports/recentCapturedGoodsReport")
                      }
                    >
                      <AssessmentIcon fontSize="inherit" />
                    </IconButton>
                  </Tooltip>
                </Box>
              ),
            }}
            actions={[
              {
                icon: "delete",
                tooltip: "Delete",
                onClick: (event, rowData) => deleteCaptureGoods(event, rowData),
                disabled: moduleAccess.deleteaccess === "Y" ? false : true,
                position: "auto",
              },
              {
                icon: () => <ChatIcon />,
                tooltip: "Comment",
                onClick: (event, rowData) => getComments(event, rowData),
                disabled: moduleAccess.editaccess === "Y" ? false : true,
              },
            ]}
            options={{
              rowStyle: (rowData) => {
                if (rowData.expiryflag === "1") {
                  return { backgroundColor: "#FFBF00" };
                } else if (rowData.expiryflag === "2") {
                  return { backgroundColor: "rgb(244, 67, 54)" };
                }
                return {};
              },
              maxBodyHeight: 670,
              paging: true,
              pageSize: 25,
              pageSizeOptions: [25, 50, 100],
              headerStyle: {
                backgroundColor: "rgba(255,255,255,1)",
                color: "black",
              },
            }}
            // components={{
            //   Pagination: props => (
            //                <TablePagination
            //                {...props}
            //               rowsPerPageOptions={[5, 10, 20, 30]}
            //               rowsPerPage={pageSize}
            //               // count={pageSize}
            //               // page={pageNumber}
            //               onPageChange={(e, page) =>
            //                 handleChangePage(page + 1)
            //               }
            //               onRowsPerPageChange={event => {
            //                 handleChangeRowPerPage(event.target.value);
            //               }}
            //         />
            //       ),
            // }}
          />
        </div>
        {/* </Container> */}

        {/* </Container> */}
        <LandingPageFooter />
        <ConfirmationDialog
          openDialog={openReceivedGoodsDialog}
          closeDialog={setOpenReceivedGoodsDialog}
          title="Can you please Confirm?"
          popupTitle="Capture Goods"
          onSubmit={enableDoubleConfirm}
          onCancel={onReceivedGoodsCancelClick}
          CancelButtonText="Continue Scanning"
          OkButtonText="Create New session"
        />
        <ConfirmationDialog
          openDialog={openDoubleConfirmDialog}
          closeDialog={setOpenDoubleConfirmDialog}
          title="The scanned data will be deleted. Do you want to create new session?"
          popupTitle="Capture Goods"
          onSubmit={onReceivedGoodsOkButtonClick}
          onCancel={onReceivedGoodsCancelClick}
          CancelButtonText="No"
          OkButtonText="Yes"
        />
        <ConfirmationDialog
          openDialog={opentoteDialog}
          closeDialog={setOpentoteDialog}
          title="Do you want proceed with new TOTE number?"
          popupTitle="Capture Goods"
          onSubmit={ontoteOkButtonClick}
          hideCancel={true}
        />
        <ConfirmationDialog
          title="Do you want proceed with new Supplier?"
          openDialog={opensupplierDialog}
          popupTitle="Capture Goods"
          onSubmit={onsupplierOkButtonClick}
          hideCancel={true}
        />
        <ConfirmationDialog
          title="Do you want to create a new record for the barcode ?"
          openDialog={openDialog}
          closeDialog={setOpenDialog}
          popupTitle="Capture Goods"
          onSubmit={onOkButtonClick}
        />
        <ConfirmationDialog
          title="Do you wish to proceed?"
          openDialog={openDeleteDialog}
          closeDialog={setOpenDeleteDialog}
          popupTitle="Goods Receivables"
          onSubmit={onDeleteOkClick}
        />
        <ConfirmationDialog
          title="All the products of this NDC and the Lot# will be deleted, you may need to rescan all the products of the same NDC/UPC and lot"
          openDialog={confirmDeleteMultipleDialog}
          closeDialog={setConfirmDeleteMultipleDialog}
          onSubmit={confirmDeleteMultipleClick}
        />
        <ConfirmationDialog
          title="Scanned item is a prescription product."
          openDialog={openRxDialog}
          closeDialog={setOpenRxDialog}
          popupTitle="Goods Receivables"
          onSubmit={onRxOkButtonClick}
          OkButtonText="Enter Manually"
          CancelButtonText="Scan Matrix Data"
          onCancel={() => {
            setCaptureGoods({
              ...captureGoods,
              barcode: "",
            });
            setOpenRxDialog(false);
          }}
          showCloseButton={true}
        />
        <Popup
          title="Goods Receivables - Manual"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <Grid
            component="label"
            container
            alignItems="center"
            spacing={1}
            className={classes.switch}
          >
            <RadioGroup
              row
              aria-label="scan"
              name="row-radio-buttons-group"
              value={openOTCManualDialog ? "OTC" : "RX"}
              onChange={handleChecked}
            >
              <FormControlLabel
                default
                value="OTC"
                control={<Radio style={{ color: "rgb(22, 177, 255)" }} />}
                label="OTC"
              />
              <FormControlLabel
                value="RX"
                control={<Radio style={{ color: "rgb(22, 177, 255)" }} />}
                label="RX"
              />
            </RadioGroup>
          </Grid>
          {openOTCManualDialog ? (
            <AddManualOtcProductForm
              addOrEdit={addOrEditForManualOTC}
              recordForEdit={recordForEditForManualOTC}
              addOtcManualProduct={addOtcManualProduct}
              captureGoodsState={captureGoods}
            />
          ) : (
            <GoodReceivablePhysicalInventoryForm
              addOrEdit={addOrEdit}
              recordForEdit={recordForEdit}
              addPhysicalInventory={addPhysicalInventory}
              captureGoodsState={captureGoods}
            />
          )}
        </Popup>
        <Popup
          title="Goods Receivables - OTC"
          openPopup={openOTCPopup}
          setOpenPopup={setOpenOTCPopup}
        >
          <AddOtcProductForm
            addOrEdit={addOrEditForOTC}
            recordForEdit={recordForEditForOTC}
            addOtcProduct={addOtcProduct}
            captureGoodsState={captureGoods}
          />
        </Popup>
        <Popup
          title="Goods Receivables - Rx"
          openPopup={openRxPopup}
          setOpenPopup={setOpenRxPopup}
        >
          <AddRxProductForm
            addOrEdit={addOrEditForRx}
            recordForEdit={recordForEditForRx}
            addRxProduct={addRxProduct}
            captureGoodsState={captureGoods}
          />
        </Popup>
        <CommentPopup
          title="Add Comments"
          openDialog={openCommentPopup}
          closeDialog={setOpenCommentPopup}
          comment={comment}
          onCommentChange={setComment}
          onSubmit={handleCommentSubmit}
          OkButtonText="Submit"
        />
      </Base>
    </div>
  );
}

const mapStateToDispatch = (state) => ({
  captureGoodsResponse: state.captureGoodsResponse,
});

const mapDispatchToProps = (dispatch) => {
  return {
    addPhysicalInventory: (physicalInventory) =>
      dispatch(addPhysicalInventoryAction(physicalInventory)),
    addOtcProduct: (otcProduct) => dispatch(addOtcProductAction(otcProduct)),
    addRxProduct: (rxProduct) => dispatch(addRxProductAction(rxProduct)),
    addOtcManualProduct: (otcManualProduct) =>
      dispatch(addOtcManualProductAction(otcManualProduct)),
  };
};

export default connect(
  mapStateToDispatch,
  mapDispatchToProps
)(CaptureReceivedGoods);
